export const iconFontAwesomeToggleStar = (
	<i className="fa-solid fa-star"></i>
);
